<template>
  <div class="order-meal-card">
    <v-img
      v-if="transaction.food.image?.name"
      class="meal-img"
      :style="{
        'max-width': foodImgSize + 'px',
        'max-height': foodImgSize + 'px',
        'min-width': foodImgSize + 'px',
        'min-height': foodImgSize + 'px',
      }"
      :height="foodImgSize"
      :width="foodImgSize"
      :src="imgSrc(transaction.food.image.name)"
      style="background-color: #b7b7b7"
    />
    <v-avatar class="meal-img" v-else :size="foodImgSize" color="#b7b7b7">
      <v-icon dark size="36">mdi-food</v-icon>
    </v-avatar>
    <div class="meal-title">
      <span
        :class="settings.font.uppercase && 'text-uppercase'"
        :style="{ fontSize: foodFontSize }"
      >
        {{ toLatin(transaction.food.name) }}
      </span>
    </div>
    <div v-if="transaction.quantity > 1" class="quantity-badge">
      x{{ transaction.quantity }}
    </div>
  </div>
</template>

<script>
import conf from "@/config";
export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    foodImgSize() {
      return this.settings?.image?.size || 64;
    },
    foodFontSize() {
      return this.settings?.font?.size?.food + "px";
    },
  },
  methods: {
    imgSrc(name) {
      return (
        conf.apiUrlBase +
        "/gallery/" +
        this.$store.state.company.restaurant.id +
        "/medium/" +
        name
      );
    },
  },
};
</script>

<style scoped>
.order-meal-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(243, 115, 56, 0.12);
  padding: 8px 24px 8px 8px;
  position: relative;
  min-height: 80px;
}
.meal-img {
  border-radius: 12px;
  object-fit: cover;
  margin-right: 18px;
}
.meal-title {
  flex: 1;
  font-family: "Poppins", Tahoma, sans-serif;
  font-weight: 700;
  color: #555;
  font-size: 1.1rem;
  line-height: 1.2;
  word-break: break-word;
}
.quantity-badge {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(50%);
  background: #ff7a2f;
  color: #fff;
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 2px;
  border-radius: 50px;
  min-width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(243, 115, 56, 0.18);
  z-index: 2;
  border: 3px solid #fff;
}
</style>
